import { Modal, ModalProps } from '@bcp-nextgen-dx-component-factory/design-system';
import { useModal } from '@hooks';

import { Modals } from '../..';

export interface AppModalProps extends ModalProps {
	modalName: Modals;
	children?: React.ReactNode;
}

export const AppModal = ({ modalName, children, onHide, ...props }: AppModalProps) => {
	const modal = useModal(modalName);

	const handleOnHide = () => {
		// manage modal visibility
		modal.hide();

		// callback function
		onHide?.();
	};

	return (
		<Modal onHide={handleOnHide} {...props}>
			{children}
		</Modal>
	);
};
